"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getInjectedRoutes = void 0;
var AuthControlledNavigation_1 = require("../navigation/AuthControlledNavigation");
var react_router_dom_1 = require("react-router-dom");
var react_1 = __importDefault(require("react"));
var ioc_1 = require("../ioc");
/**
 * This is a function that will return an array of JSXElements of the routes registered in the ioc container by each
 * individual module, each module is able to register 2 types of routes, a standard route and a redirect. On
 * registration of routes each route can set whether or not it has to be authenticated or the required permissions
 */
function getInjectedRoutes(args) {
    // We get a list of routes we're allowed to access and build normal routes for these
    var allowedRoutes = ioc_1.getCoreContainer()
        .getAll(ioc_1.CORE_TYPES.Route)
        .filter(AuthControlledNavigation_1.userCanAccessRoute(args.userIsAuthenticated, args.userPermissions));
    // We get a list of routes we're not allowed to access and replace with a redirect to login
    var disallowedRouteRedirects = ioc_1.getCoreContainer()
        .getAll(ioc_1.CORE_TYPES.Route)
        .filter(AuthControlledNavigation_1.userCannotAccessRoute(args.userIsAuthenticated, args.userPermissions))
        .map(function (d) { return (__assign(__assign({}, d), { type: 'redirect', to: '/auth/login', permissions: undefined, authenticated: false })); });
    var injectedRoutes = __spreadArray(__spreadArray([], allowedRoutes), disallowedRouteRedirects).map(function (route) {
        if (route.type === 'redirect') {
            return react_1.default.createElement(react_router_dom_1.Redirect, __assign({ key: route.path }, route));
        }
        if (route.type === 'component') {
            var path = route.path, layoutOverride = route.layoutOverride, layoutProps_1 = route.layoutProps, renderLayout = route.renderLayout, Component_1 = route.component, exact = route.exact;
            var Layout_1 = layoutOverride !== null && layoutOverride !== void 0 ? layoutOverride : args.defaultLayout;
            var render = renderLayout === false
                ? function () { return react_1.default.createElement(Component_1, null); }
                : function () { return (react_1.default.createElement(Layout_1, __assign({}, layoutProps_1),
                    react_1.default.createElement(Component_1, null))); };
            return react_1.default.createElement(react_router_dom_1.Route, { key: path, path: path, render: render, exact: exact });
        }
        return null;
    });
    return injectedRoutes;
}
exports.getInjectedRoutes = getInjectedRoutes;
;
//# sourceMappingURL=getInjectedRoutes.js.map